export const SET_IS_GENERATING_REPORT = "SET_IS_GENERATING_REPORT";

export const setIsGeneratingReport = (value) => ({
  type: SET_IS_GENERATING_REPORT,
  payload: value,
});
